import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IGroupedProducts, IProducts } from '../models/products.model';

export const groupedProductsFeatureKey = 'getGroupedProducts';

export interface GroupedProductsState {
  loadGroupedProducts: string;
  loadGroupedProductsResponse: IGroupedProducts[];
  loadGroupedProductsFailure: Error | any;
}

export const initialState: GroupedProductsState = {
  loadGroupedProducts: undefined,
  loadGroupedProductsResponse: undefined,
  loadGroupedProductsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGroupedCustomerProducts, (state, action) => ({
    ...state,
    loadGroupedProducts: action.request
  })),
  on(actions.loadGroupedCustomerProductsSuccess, (state, action) => ({
    ...state,
    loadGroupedProductsResponse: action.response
  })),
  on(actions.loadGroupedCustomerProductsFailure, (state, action) => ({
    ...state,
    loadGroupedProductsFailure: action.error
  }))
);

export const getGroupedProductsResponse = (state: GroupedProductsState) => state.loadGroupedProductsResponse;
